import React from 'react';
import { Outlet } from 'react-router-dom';
import { ErrorContext } from '../../store/contexts';

export const ErrorLayout = () => {
    return (
        <ErrorContext.Provider value={{}}>
            <div className="error-layout d-flex flex-column justify-content-center align-items-center w-100 min-vh-100 bg-light">
                <main className="error-page container">
                    <div className="row">
                        <div className="col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3 my-5">
                            <Outlet />
                        </div>
                    </div>
                </main>
            </div>
        </ErrorContext.Provider>
    );
};
